export const EMBEDDED_PAUSE_SVG =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72"><rect x="16" y="14" width="14" height="44" rx="5" fill="%23f7b538"/><rect x="42" y="14" width="14" height="44" rx="5" fill="%23f7b538"/></svg>'

export const EMBEDDED_POINTER_RING_SVG =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><circle cx="48" cy="48" r="32" fill="none" stroke="%23f7b538" stroke-width="4" stroke-opacity="0.5"/><circle cx="48" cy="48" r="20" fill="%23fbbf24" fill-opacity="0.35"/></svg>'

export const EMBEDDED_UI_CLICK_WAV ='audio/ui-click.wav'

export const INTRO_MUSIC = 'audio/intro-theme.wav'

export const CAMPAIGN_THEME: string | undefined = undefined

export const LOADING_TIPS = [
  'Busca el dispositivo en todas las habitaciones.',
  'Es posible que tengas de derrotar a los enemigos para obtener el dispositivo.',
]
